import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import {getGetHeaders} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import Avatar from 'material-ui/Avatar';
import TextField from 'material-ui/TextField';
import IncomingIcon from 'material-ui/svg-icons/action/assignment-returned';
import MemoIcon from 'material-ui/svg-icons/action/assignment';
import ReceivedIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import {viewStyles} from '../shared/styles-view';

const styles = {
    field: {display: 'block', width: 'auto', minWidth: 100, margin: '0 1em 0 0', verticalAlign: 'top'},
    fieldInline: {display: 'inline-block', width: 'auto', minWidth: 100, margin: '0 1em 0 0', verticalAlign: 'top'},
    title: {
        fontSize: '24px',
        color: 'rgba(33, 33, 33, 0.87)',
        display: 'block',
        width: '100%',
        lineHeight: '36px',
        clear: 'both'
    },
    description: {display: 'block', fontSize: '14px', color: 'rgb(158, 158, 158)', margin: '0px 16px 1em 0'}
};

class TransferDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: {}
        };
    }

    componentWillMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.record.transfer_id !== this.props.record.transfer_id) {
            this.fetchData();
        }
    }

    /**
     * Get Transfer data by Transfer ID
     */
    fetchData() {
        const transfer_id = (this.props.record && this.props.record.transfer_id) ? this.props.record.transfer_id : '';
        let resource = inventoryResources.Transfers.GET_ONE({id: transfer_id});

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processData(result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log('Error', error.response);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    }

    /**
     * Process array of Transfers
     *
     * @param data
     */
    processData(data) {
        if (data && data.inv_transfer_model) {
            const record = {
                location_from: (data.inv_transfer_model.location_from) ? data.inv_transfer_model.location_from : '',
                location_to: (data.inv_transfer_model.location_to) ? data.inv_transfer_model.location_to : '',
                memo: (data.inv_transfer_model.memo) ? data.inv_transfer_model.memo : '',
                received: (data.inv_transfer_model.received),
                transfer_id: (data.inv_transfer_model.transfer_id) ? data.inv_transfer_model.transfer_id : '',
            };
            this.setState({
                record: record
            });
        }
    }

    render() {
        const {
            description,
            transferType
        } = this.props;

        const {
            record
        } = this.state;

        let icon;
        if (transferType === 'incoming') {
            icon = <IncomingIcon/>;
        }
        if (transferType === 'memo') {
            icon = <MemoIcon/>;
        }
        if (transferType === 'received') {
            icon = <ReceivedIcon/>;
        }

        return (
            <div>
                {record.transfer_id &&
                <Fragment>
                    <span style={styles.title}>
                        <Avatar icon={icon} style={viewStyles.avatar} className="avatar-title"/>
                        Transfer #{record.transfer_id}
                    </span>

                    {description &&
                    <span style={styles.description}>
                        {description}
                    </span>
                    }

                    <TextField floatingLabelText="From Location" name="location_from"
                               value={record.location_from} disabled
                               style={styles.fieldInline} underlineShow={false}/>
                    <TextField floatingLabelText="To Location" name="location_to"
                               value={record.location_to} disabled
                               style={styles.fieldInline} underlineShow={false}/>
                    <TextField floatingLabelText="Memo" name="memo"
                               value={record.memo} disabled
                               style={styles.field} underlineShow={false}/>
                </Fragment>
                }
            </div>
        )
    }
}

TransferDetail.propTypes = {
    basePath: PropTypes.string,
    description: PropTypes.any,
    location: PropTypes.object,
    system: PropTypes.string,
    transferType: PropTypes.string
};

TransferDetail.defaultProps = {
    location: null,
    memo: null,
    transferType: 'incoming'
};

export default TransferDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferDetail.js